import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-web-assets-page',
  templateUrl: './assets.page.html',
  styleUrls: ['./assets.page.scss'],
  standalone: false,
})
export class AssetsPage {
  tabs = [
    { label: 'Asset Types', routerLink: 'asset-types' },
    { label: 'Properties', routerLink: 'properties' },
    // Future: { label: 'Assignments', routerLink: 'assignments' },
  ];
}
